import React, { useEffect, useState } from "react";
import sphereLogoConcept2 from "../assets/sphere-logo-concept-2-transparent.png";

const LOGO_SESSION_KEY = "sphere-logo-seen";
const WORDMARK = "Sphere IT Solutions";

const canUseStorage = () => typeof window !== "undefined" && "sessionStorage" in window;

const hasSeenLogoAnimation = () => {
  try {
    return canUseStorage() && window.sessionStorage.getItem(LOGO_SESSION_KEY) === "true";
  } catch {
    return true;
  }
};

const WORDMARK_PARTS = [
  { key: "sphere", text: "Sphere" },
  { key: "it", text: "IT", gold: true },
  { key: "solutions", text: "Solutions" },
];

export const LogoMark = ({ className = "" }) => {
  return (
    <img
      src={sphereLogoConcept2}
      alt=""
      width="48"
      height="48"
      aria-hidden="true"
      className={`logo-mark logo-mark--concept-2 shrink-0 ${className}`}
      decoding="async"
      draggable="false"
    />
  );
};

const Wordmark = ({ mono }) => {
  let letterIndex = 0;

  return (
    <span className="brand-logo__wordmark font-heading" aria-hidden="true">
      {WORDMARK_PARTS.map((part, partIndex) => (
        <React.Fragment key={part.key}>
          <span
            className={part.gold && !mono ? "brand-logo__word-part brand-logo__letter--gold" : "brand-logo__word-part"}
            data-logo-part={part.key}
          >
            {part.text.split("").map((char) => {
              const index = letterIndex;
              letterIndex += 1;
              return (
                <span
                  key={`${part.key}-${char}-${index}`}
                  className={part.gold && !mono ? "brand-logo__letter brand-logo__letter--gold" : "brand-logo__letter"}
                  style={{ "--letter-index": index }}
                >
                  {char}
                </span>
              );
            })}
          </span>
          {partIndex < WORDMARK_PARTS.length - 1 && (
            <span className="brand-logo__letter brand-logo__space" style={{ "--letter-index": letterIndex++ }}> </span>
          )}
        </React.Fragment>
      ))}
    </span>
  );
};

// Reusable Sphere IT Solutions logo. The complete static logo is always rendered;
// animation classes only enhance the first view in a browsing session.
export const Logo = ({ className = "", showText = true, mono = false }) => {
  const [shouldAnimate] = useState(() => !hasSeenLogoAnimation());

  useEffect(() => {
    if (!shouldAnimate) return;

    try {
      if (canUseStorage()) {
        window.sessionStorage.setItem(LOGO_SESSION_KEY, "true");
      }
    } catch {
      // Storage may be blocked; the visible static logo remains the fallback.
    }
  }, [shouldAnimate]);

  return (
    <span
      className={`brand-logo inline-flex items-center gap-2.5 whitespace-nowrap ${className}`}
      aria-label="Sphere IT Solutions"
      data-logo-animate={shouldAnimate ? "true" : "false"}
    >
      <LogoMark />
      {showText && <Wordmark mono={mono} />}
    </span>
  );
};

export default Logo;
